'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var align = _ref.align,
      styles = _ref.styles;
  var rhythm = _ref2.rhythm,
      scale = _ref2.scale,
      treatments = _ref2.treatments;

  var defaultStyles = {
    root: {
      textAlign: align
    },

    icon: {
      marginBottom: rhythm(0.66)
    },

    label: _extends({
      display: 'block',
      opacity: 0.5,
      marginBottom: rhythm(0.33),
      fontSize: scale(-1)
    }, treatments.button),

    amount: _extends({
      fontSize: scale(3)
    }, treatments.head)
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/metric/styles.js
// module id = 846
// module chunks = 0